import OrganizationListingPage from '@/pages/admin/OrganizationListingPage/OrganizationListingPage.vue'

export default OrganizationListingPage
